if (!customElements.get('abc-hero-slider')) {
  customElements.define('abc-hero-slider', class AbcHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.track = this.querySelector('[data-track]');
      this.count = this.querySelector('[data-count]');
      this.index = 0;
      this.seconds = Number(this.dataset.seconds) || 5;
      this.dragX = null;

      if (!this.track || this.slides.length === 0) {
        this.hidden = true;
        return;
      }

      this.buildThumbs();
      if (this.slides.length < 2) return;

      this.querySelector('[data-controls]').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1));

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.play();
      });
      this.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;
        this.dragX = event.clientX;
      });
      this.addEventListener('pointerup', (event) => {
        if (this.dragX == null) return;
        const delta = event.clientX - this.dragX;
        this.dragX = null;
        if (Math.abs(delta) > 50) this.show(this.index + (delta < 0 ? 1 : -1));
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.play();
      });

      this.show(0);
    }

    buildThumbs() {
      const list = this.querySelector('[data-thumbs]');
      this.slides.forEach((slide, index) => {
        const source = slide.querySelector('img');
        const title = slide.querySelector('.abc-hero__product-title')?.textContent?.trim() || 'Best seller';
        const item = document.createElement('li');
        const button = document.createElement('button');
        const image = document.createElement('img');
        const srcset = source?.getAttribute('srcset') || '';
        button.type = 'button';
        button.className = 'abc-hero__thumb';
        button.dataset.thumb = '';
        button.setAttribute('aria-label', title);
        image.alt = '';
        image.width = 160;
        image.height = 160;
        image.src = srcset.split(',')[0].trim().split(' ')[0] || source.src;
        button.appendChild(image);
        button.addEventListener('click', () => this.show(index));
        item.appendChild(button);
        list.appendChild(item);
      });
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
    }

    show(index) {
      const total = this.slides.length;
      this.index = (index + total) % total;
      this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
      this.slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === this.index ? 'false' : 'true');
      });
      this.thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === this.index;
        thumb.classList.toggle('is-active', active);
        if (active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
        if (active) {
          thumb.classList.remove('is-active');
          void thumb.offsetWidth;
          thumb.classList.add('is-active');
        }
      });
      if (this.count) this.count.textContent = `${this.index + 1} / ${total}`;
      this.play();
    }

    play() {
      this.stop();
      if (this.slides.length < 2 || this.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = window.setInterval(() => this.advance(), this.seconds * 1000);
    }

    advance() {
      const total = this.slides.length;
      this.index = (this.index + 1) % total;
      this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
      this.slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === this.index ? 'false' : 'true');
      });
      this.thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === this.index;
        thumb.classList.toggle('is-active', active);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
          thumb.classList.remove('is-active');
          void thumb.offsetWidth;
          thumb.classList.add('is-active');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      if (this.count) this.count.textContent = `${this.index + 1} / ${total}`;
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  });
}
